<template>
  <div>
    <b-row class="align-items-center mx-0">
      <b-col class="pl-0">
        <b-form-group label="Nome:">
          <b-form-input
            v-model="plano.nome"
            placeholder="Nome"
            :state="validateState('nome')"
          />
          <b-form-invalid-feedback>
            Nome é um campo obrigatório.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="auto">
        <b-form-group class="mb-0 mr-2">
          <b-form-checkbox v-model="plano.visivel" switch value="1">
            Visível
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-checkbox
      switch
      v-model="plano.plano_consultor"
      name="plano_consultor"
      class="mb-4"
      :value="1"
      :unchecked-value="0"
    >
      Plano Consultor
    </b-form-checkbox>

    <b-form-group label="Valor">
      <number-format
        placeholder="Valor"
        name="valor"
        v-model.number="plano.valor"
        :state="validateState('valor')"
      ></number-format>
      <b-form-invalid-feedback>
        Este é um campo obrigatório!
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Descrição">
      <b-form-textarea placeholder="Descrição..." v-model="plano.descricao">
      </b-form-textarea>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import NumberFormat from "@/components/Form/NumberFormat.vue";

import { mapState } from "vuex";

export default {
  components: { NumberFormat },
  mixins: [validationMixin],
  data: () => ({}),
  validations: {
    plano: {
      nome: {
        required,
        minLength: minLength(3),
      },
      valor: {
        required,
      },
    },
  },
  computed: {
    ...mapState("planos", ["plano"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.plano[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.plano.$touch();
      return !this.$v.plano.$anyError;
    },
  },
  created() {},
};
</script>
